var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/add_image.4a40d56c.png","uri@2x": __webpack_public_path__ + "static/media/add_image.39676ff1.png","uri@3x": __webpack_public_path__ + "static/media/add_image.37bfc7a1.png",
    width: 16,
    height: 16
});